<div class="search-fields m-t-20">
  <form class="policy-search-criteria-form tab-grid" id="policy-search-criteria" nz-form
    [formGroup]="policySearchCriteriaForm" (ngSubmit)="attemptToSubmit()">
    <nz-form-item>
      <nz-form-label [nzSpan]="24"> <span translate>Proposal Number</span></nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input formControlName="proposalNum" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24"> <span translate>Policy Commencement Date</span></nz-form-label>
      <nz-form-control [nzSpan]="24">
        <nz-date-picker style="width:100%" formControlName="policyCommencementDt" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24"> <span translate>First Name</span> </nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input value="" formControlName="firstName" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24"> <span translate>Last Name</span></nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input value="" formControlName="lastName" />
      </nz-form-control>
    </nz-form-item>
  </form>
</div>
<div class="multisearch-grid">
  <div>
    <button nz-button nzType="primary" (click)="searchPolicy()">
      Search for Policy
    </button>
  </div>
  <div></div>
  <div></div>
</div>
<div class="search-results m-t-20">
  <!-- Show Result Tables -->
  <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="searchCustOrPolicyLoading">

    <!-- Policy Search Results -->
    <div>
      <nz-table *ngIf="policyDataSet && policyDataSet.length > 0" #policySearchTable [nzData]="policyDataSet" [nzSize]="'middle'"
        [nzShowPagination]="true">
        <thead>
          <tr>
            <th></th>
            <th><span translate>Proposal No</span></th>
            <th><span translate>Start Date</span></th>
            <th><span translate>Client Number</span></th>
            <th><span translate>First Name</span></th>
            <th><span translate>Last Name</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of policySearchTable.data">
            <td><label nz-checkbox nzValue="data" [(ngModel)]="data['selected']" (ngModelChange)="emitSelectedPolicies()"></label></td>
            <td>{{data.proposalNum}}</td>
            <td>{{getDateString(data.policyCommencementDt)}}</td>
            <td>{{data.clientNum}}</td>
            <td>{{data.firstName}}</td>
            <td>{{data.lastName}}</td>
          </tr>

        </tbody>
      </nz-table>
    </div>
  </nz-skeleton>

</div>